var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#29845A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7803 7.96967C18.0732 8.26256 18.0732 8.73744 17.7803 9.03033L11.2803 15.5303C10.9874 15.8232 10.5126 15.8232 10.2197 15.5303L6.96967 12.2803C6.67678 11.9874 6.67678 11.5126 6.96967 11.2197C7.26256 10.9268 7.73744 10.9268 8.03033 11.2197L10.75 13.9393L16.7197 7.96967C17.0126 7.67678 17.4874 7.67678 17.7803 7.96967Z",
    fill: "#F8FFFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green_tick.b7699b9076a93ef9a5fb631fd4ff977b.svg";
export { ForwardRef as ReactComponent };